import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { permission } from '../../_helpers/access.control';
import { HeaderComponent } from '../header/header.component';
import { sidebarurl } from './sidebar-url';

@Component({
    providers: [HeaderComponent],
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit {
    SubCategory: any;
    public currentUrl = '';
    public username = '';
    public userRole = '';
    public noSlashesUrl = '';
    nav: any;
    navArr: any;
    menuUrl: {};

    constructor(private router: Router, private headComp: HeaderComponent) {
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
            }
        });
        // tslint:disable-next-line:no-unused-expression
    }
    ngOnInit() {
        this.menuUrl = sidebarurl;
        this.username = sessionStorage.getItem('username');
        this.userRole = sessionStorage.getItem('userRole');
        this.username = this.username[0].toUpperCase() + this.username.slice(1);
        this.noSlashesUrl = this.currentUrl.replace(/\//g, '');
        sessionStorage.setItem('noSlashesUrl', this.noSlashesUrl);
        this.setPermitedNav(this.userRole);
    }

    OnShowCategory(CategoryName) {
        if (this.SubCategory === CategoryName) {
            this.SubCategory = '';
        } else {
            this.SubCategory = CategoryName;
        }
    }

    gotoURL(url) {
        if(url != undefined){
            this.noSlashesUrl = url.replace(/\//g, '');
            sessionStorage.setItem('noSlashesUrl', this.noSlashesUrl);
            this.router.navigate([url]);
            this.headComp.slideToggle();
        }
    }

    checkNavCondition(navUrl) {
        if (typeof this.navArr[0] !== 'undefined' && this.navArr[0] === 'all') {
            return true;
        } else {
            const found = this.navArr.find(function(element) {
                return element === navUrl;
            });
            if (typeof found !== 'undefined' && found !== '') {
                return true;
            } else {
                return false;
            }
        }
    }

    setPermitedNav(userVal) {
        const loggeduser = userVal.toLowerCase();
        this.navArr = permission.accessible[loggeduser];
    }
}
